import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach admin JWT automatically when present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("sfh_admin_token");
  if (token && config.url?.includes("/admin/")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ---------------- Citizen (public) ----------------
export const getFechasDisponibles = (tipoServicio) =>
  client.get("/citizen/fechas-disponibles", { params: { tipo_servicio: tipoServicio } }).then((r) => r.data);

export const createSolicitud = (payload) => client.post("/citizen/solicitudes", payload).then((r) => r.data);

export const trackSolicitud = (ticketCode, contacto) =>
  client.get("/citizen/solicitudes/track", { params: { ticket_code: ticketCode, contacto } }).then((r) => r.data);

// ---------------- Admin (protected) ----------------
export const adminLogin = (email, password) =>
  client.post("/admin/login", { email, password }).then((r) => r.data);

export const adminMe = () => client.get("/admin/me").then((r) => r.data);

export const adminListSolicitudes = (params) => client.get("/admin/solicitudes", { params }).then((r) => r.data);

export const adminUpdateSolicitud = (id, payload) => client.patch(`/admin/solicitudes/${id}`, payload).then((r) => r.data);

export const adminHistorialSolicitud = (id) => client.get(`/admin/solicitudes/${id}/historial`).then((r) => r.data);

export const adminStats = () => client.get("/admin/stats").then((r) => r.data);

export const adminExportSolicitudes = async (params) => {
  const response = await client.get("/admin/solicitudes/export", { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "solicitudes_sfh.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const adminRunRemindersNow = () => client.post("/admin/reminders/run-now").then((r) => r.data);

export const adminCrearSolicitudTelefono = (payload) =>
  client.post("/admin/solicitudes/telefono", payload).then((r) => r.data);

export const adminImportarIslas = (file) => {
  const form = new FormData();
  form.append("file", file);
  return client.post("/admin/islas/importar", form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

export const adminListarIslas = () => client.get("/admin/islas").then((r) => r.data);
export const adminEditarIsla = (id, payload) => client.put(`/admin/islas/${id}`, payload).then((r) => r.data);
export const adminBorrarIsla = (id) => client.delete(`/admin/islas/${id}`).then((r) => r.data);
export const adminCrearIsla = (payload) => client.post("/admin/islas", payload).then((r) => r.data);

export const adminExportarIslas = async () => {
  const response = await client.get("/admin/islas/export", { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "islas_contenedores_sfh.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const adminOptimizarRuta = (params) => client.get("/admin/rutas/optimizar", { params }).then((r) => r.data);

// ---------------- Islas de contenedores (público) ----------------
export const getIslasContenedores = () => client.get("/citizen/islas-contenedores").then((r) => r.data);

// ---------------- Punto Limpio (public) ----------------
export const getCatalogoResiduos = () => client.get("/puntolimpio/catalogo-residuos").then((r) => r.data);

export const createPuntoLimpioCheckin = (payload) =>
  client.post("/puntolimpio/checkins", payload).then((r) => r.data);

export const generarMiQr = (payload) =>
  client.post("/puntolimpio/generar-mi-qr", payload).then((r) => r.data);

export const getPuntoLimpioEstadisticas = () =>
  client
    .get("/puntolimpio/estadisticas-publicas", {
      headers: { Authorization: `Bearer ${localStorage.getItem("sfh_admin_token") || ""}` },
    })
    .then((r) => r.data);

export const getPuntoLimpioInfo = () => client.get("/puntolimpio/info").then((r) => r.data);

export const getPuntoLimpioNoAdmitidos = () => client.get("/puntolimpio/no-admitidos").then((r) => r.data);

// ---------------- Punto Limpio (admin) ----------------
export const adminListCheckins = (estado) =>
  client.get("/admin/puntolimpio/checkins", { params: estado ? { estado } : {} }).then((r) => r.data);

export const adminCrearCheckinTelefono = (payload) =>
  client.post("/admin/puntolimpio/checkins/telefono", payload).then((r) => r.data);

export const adminConfirmarCheckin = (id, payload) =>
  client.post(`/admin/puntolimpio/checkins/${id}/confirmar`, payload).then((r) => r.data);

export const adminRechazarCheckin = (id) =>
  client.post(`/admin/puntolimpio/checkins/${id}/rechazar`).then((r) => r.data);

export const adminCrearSalida = (payload) =>
  client.post("/admin/puntolimpio/salidas", payload).then((r) => r.data);

export const adminSubirAdjuntoPuntoLimpio = (objectId, tipo, file) => {
  const form = new FormData();
  form.append("tipo", tipo);
  form.append("file", file);
  return client
    .post(`/admin/puntolimpio/eventos/${objectId}/adjuntos`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const adminListEventosPuntoLimpio = (params) =>
  client.get("/admin/puntolimpio/eventos", { params }).then((r) => r.data);

export const adminListApuntados = () => client.get("/admin/puntolimpio/apuntados").then((r) => r.data);

export const adminSyncPuntoLimpio = (full) =>
  client.post("/admin/puntolimpio/sync", null, { params: { full: !!full } }).then((r) => r.data);

export const adminStatsPuntoLimpio = () => client.get("/admin/puntolimpio/stats").then((r) => r.data);

// ---------------- MFA (2FA) ----------------
export const mfaVerify = (challengeToken, code) =>
  client.post("/admin/mfa/verify", { challenge_token: challengeToken, code }).then((r) => r.data);

export const mfaEnrollStart = () => client.post("/admin/mfa/enroll/start").then((r) => r.data);

export const mfaEnrollConfirm = (code) => client.post("/admin/mfa/enroll/confirm", { code }).then((r) => r.data);

export const mfaDisable = () => client.post("/admin/mfa/disable").then((r) => r.data);

// ---------------- Bonificación tasa de basuras ----------------
export const bonificacionListReglas = () => client.get("/admin/bonificacion/reglas").then((r) => r.data);

export const bonificacionCrearRegla = (payload) =>
  client.post("/admin/bonificacion/reglas", payload).then((r) => r.data);

export const bonificacionGenerarFichero = (periodo) =>
  client.post("/admin/bonificacion/ficheros/generar", { periodo }).then((r) => r.data);

export const bonificacionListFicheros = () => client.get("/admin/bonificacion/ficheros").then((r) => r.data);

export const bonificacionAprobarFichero = (id) =>
  client.post(`/admin/bonificacion/ficheros/${id}/aprobar`).then((r) => r.data);

export const bonificacionDescargarFichero = async (id, tipo, periodo) => {
  const response = await client.get(`/admin/bonificacion/ficheros/${id}/descargar`, {
    params: { tipo }, responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `bonificacion_${periodo}_fichero_${tipo}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const bonificacionSubirRetorno = (file) => {
  const form = new FormData();
  form.append("file", file);
  return client.post("/admin/bonificacion/retorno", form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

export const bonificacionIndicadores = () => client.get("/admin/bonificacion/indicadores").then((r) => r.data);

export const bonificacionAuditoria = () => client.get("/admin/bonificacion/auditoria").then((r) => r.data);

export const bonificacionExportarAuditoria = async () => {
  const response = await client.get("/admin/bonificacion/auditoria/export", { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "auditoria_bonificacion.csv");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const bonificacionDescargarInformePdf = async (id, periodo) => {
  const response = await client.get(`/admin/bonificacion/ficheros/${id}/informe-pdf`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `informe-bonificacion-${periodo}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// ---------------- Hacienda (exportaciones + Censo de Medio Ambiente) ----------------
export const haciendaExportarExcel = async (servicio, anio) => {
  const response = await client.get(`/admin/hacienda/export/${servicio}`, { params: { anio }, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `hacienda_${servicio}_${anio}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const haciendaGenerarCenso = (servicio, anio) =>
  client.post("/admin/hacienda/censo/generar", { servicio, anio }).then((r) => r.data);

export const haciendaListarCensos = () => client.get("/admin/hacienda/censo").then((r) => r.data);

export const haciendaFirmarCenso = (id, password) =>
  client.post(`/admin/hacienda/censo/${id}/firmar`, { password }).then((r) => r.data);

export const haciendaDescargarCensoPdf = async (id, servicio, anio) => {
  const response = await client.get(`/admin/hacienda/censo/${id}/pdf`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `censo-medio-ambiente-${servicio}-${anio}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default client;
